import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import API from "../axios";
import "../style/request.css";

const ReqApprovals = () => {

  const empDetails = JSON.parse(
    localStorage.getItem("empDetails") || "{}"
  );

  const [loading, setLoading] =
    useState(false);

  const [requestData, setRequestData] =
    useState([]);

  const [showModal, setShowModal] =
    useState(false);

  const [selectedRequest, setSelectedRequest] =
    useState(null);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });

  // FILTER
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    status: "0"
  });

  // TOAST
  const showToast = (
    message,
    type = "success"
  ) => {

    setToast({
      show: true,
      message,
      type
    });

    setTimeout(() => {

      setToast((prev) => ({
        ...prev,
        show: false
      }));

    }, 3000);
  };

  // FORMAT DATE TIME
const formatDateTime = (dateValue) => {

  if (!dateValue) return "-";

  const d = new Date(dateValue);

  let day = String(
    d.getUTCDate()
  ).padStart(2, "0");

  let month = String(
    d.getUTCMonth() + 1
  ).padStart(2, "0");

  let year =
    d.getUTCFullYear();

  let hours =
    d.getUTCHours();

  let minutes = String(
    d.getUTCMinutes()
  ).padStart(2, "0");

  let ampm =
    hours >= 12 ? "PM" : "AM";

  hours =
    hours % 12 || 12;

  hours = String(hours)
    .padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

  // FETCH APPROVALS
  const fetchRequests = async (
    fromDate = "",
    toDate = "",
    status = "0"
  ) => {

    try {

      setLoading(true);

      const res = await API.post(
        "/req-approvals",
        {
          empcode:
            empDetails.employee_code,
          fromDate,
          toDate,
          status
        }
      );

      console.log(res.data);
      setRequestData(res.data);

    } catch (err) {

      console.log(err);

      showToast(
        "Failed to fetch approvals",
        "error"
      );

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    fetchRequests();

  }, []);

  // APPROVE
const approveRequest = async (
  requestId
) => {

  try {

    setLoading(true);

    const res = await API.post(
      "/approve-request",
      {
        id: requestId,
        approvedBy:
          empDetails.emp_name,
        approvedByID:
          empDetails.employee_code,
      }
    );

    showToast(
      res.data.message,
      "success"
    );

    fetchRequests(
      filter.fromDate,
      filter.toDate,
      filter.status
    );

    setShowModal(false);

  } catch (err) {

    console.log(err);

    showToast(
      err?.response?.data?.message ||
      "Approval Failed",
      "error"
    );

  } finally {

    setLoading(false);

  }
};

  return (

    <div>

      {/* TOAST */}
      {toast.show && (
        <div
          className={`custom-toast ${toast.type}`}
        >
          {toast.message}
        </div>
      )}

      {/* LOADER */}
      {loading && (
        <div className="page-loader-request">
          <div className="loader"></div>
        </div>
      )}

      {/* FILTER */}
      <div className="row mb-lg-3 mb-1 filter-box">

        <div className="col-lg-2 col-3">

          <input
            type="date"
            className="form-control filterinp"
            value={filter.fromDate}
            onChange={(e) =>
              setFilter({
                ...filter,
                fromDate:
                  e.target.value
              })
            }
          />

        </div>

        <div className="col-lg-2 col-3">

          <input
            type="date"
            className="form-control filterinp"
            value={filter.toDate}
            onChange={(e) =>
              setFilter({
                ...filter,
                toDate:
                  e.target.value
              })
            }
          />

        </div>

        <div className="col-lg-2 col-3">

          <select
            className="form-control filterinp"
            value={filter.status}
            onChange={(e) =>
              setFilter({
                ...filter,
                status:
                  e.target.value
              })
            }
          >
            <option value="0">
              Pending
            </option>

            <option value="1">
              Approved
            </option>

          </select>

        </div>

        <div className="col-lg-2 col-3">

          <button
            className="submit-btn w-100 filterinp"
            onClick={() =>
              fetchRequests(
                filter.fromDate,
                filter.toDate,
                filter.status
              )
            }
          >
            Filter
          </button>

        </div>

      </div>

      {/* TABLE */}
      <motion.div
        className="table-responsive request-table-card"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >

        <table className="table table-bordered align-middle">

          <thead>

            <tr className="text-center">

              <th>Employee</th>

              <th>Type</th>

              <th>Date</th>

              <th>Status</th>

              <th>View</th>

            </tr>

          </thead>

          <tbody>

            {requestData.length > 0 ? (

              requestData.map(
                (item, index) => (

                  <tr
                    key={index}
                    className="text-center"
                  >

                    <td>
                      {item.empname}
                    </td>

                    <td>
                      {item.formType}
                    </td>

                    <td>

                      {new Date(
                        item.appliedFromDate
                      ).toLocaleDateString("en-GB")}

                    </td>

                    <td>

                      <span
                        className={`status-badge ${
                          item.status == 0
                            ? "Pending"
                            : "Approved"
                        }`}
                      >

                        {item.status == 0
                          ? "Pending"
                          : "Approved"}

                      </span>

                    </td>

                    <td>

                      <button
                        className="btn btn-sm btn-dark"
                        onClick={() => {

                          setSelectedRequest(item);

                          setShowModal(true);
                        }}
                      >
                        Details
                      </button>

                    </td>

                  </tr>
                )
              )

            ) : (

              <tr>

                <td
                  colSpan="5"
                  className="text-center"
                >
                  No Requests Found
                </td>

              </tr>
            )}

          </tbody>

        </table>

      </motion.div>

      {/* MODAL */}
      {showModal &&
        selectedRequest && (

        <div className="custom-modal-overlay">

          <motion.div
            className="custom-modal-box"
            initial={{
              scale: 0.8,
              opacity: 0
            }}
            animate={{
              scale: 1,
              opacity: 1
            }}
          >

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h4 className="m-0">
                Request Details
              </h4>

              <button
                className="btn btn-sm btn-danger"
                onClick={() =>
                  setShowModal(false)
                }
              >
                ✕
              </button>

            </div>

            <div className="request-detail-grid">

              <div>
                <strong>Employee</strong>

                <p>
                  {selectedRequest.empname} - {selectedRequest.empid}
                </p>
              </div>

              <div>
                <strong>Request Type</strong>
                <p>
                  {selectedRequest.formType}
                </p>
              </div>

              <div>
                <strong>Date</strong>

                <p>

                  {new Date(
                    selectedRequest.appliedFromDate
                  ).toLocaleDateString("en-GB")} - {new Date(
                    selectedRequest.appliedToDate
                  ).toLocaleDateString("en-GB")}

                </p>
              </div>

              <div>
                <strong>No of Days</strong>

                <p>

                  {selectedRequest.NoOfdays || '-'} 

                </p>
              </div>
               <div>
                <strong>Missed Swipe</strong>

                <p>

                  {selectedRequest.SwipeDetils || '-'}

                </p>
              </div>

              <div>
                <strong>Extra Duty</strong>
                <p>
                  {selectedRequest.ExtraDuty_timings || '-'}
                </p>
              </div>

              <div>
                <strong>Applied Date</strong>
                <p>
                  {new Date(
                    selectedRequest.createdDate
                  ).toLocaleDateString("en-GB")} 
                </p>
              </div>

              <div>
                <strong>Status</strong>

                <p>

                  {selectedRequest.status == 0
                    ? "Pending"
                    : "Approved"}

                </p>
              </div>

              <div>
                <strong>Approved By</strong>

                <p>

                  {selectedRequest.approvedBy || '-'}

                </p>
              </div>

            <div>
                <strong>Approved Date</strong>

                <p>
                  {formatDateTime(
                    selectedRequest.approvedDate
                  )}
                </p>
              </div>


              <div className="w-100">

                <strong>Remarks</strong>

                <p>
                  {selectedRequest.remarks}
                </p>

              </div>

            </div>

            {/* APPROVE BUTTON */}
            {selectedRequest.status == 0 && (

              <div className="text-center mt-4">

                <button
                  className="submit-btn approve-btn"
                  onClick={() =>
                    approveRequest(
                      selectedRequest.id
                    )
                  }
                >
                  Approve Request
                </button>

              </div>
            )}

          </motion.div>

        </div>
      )}

    </div>
  );
};

export default ReqApprovals;